export default function FormTextarea({ field, value, error, onChange }) {
  const handleChange = (e) => {
    onChange(field.name, e.target.value);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-200 mb-2">
        {field.label}
        {field.required && <span className="text-aw-green font-semibold text-lg ml-1">*</span>}
      </label>
      <textarea
        name={field.name}
        value={value || ""}
        onChange={handleChange}
        placeholder={field.placeholder || field.label}
        rows={field.rows || 4}
        maxLength={field.maxLength}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 transition-all duration-200 resize-y ${
          error
            ? "border-red-500 focus:ring-red-500"
            : "border-gray-300 focus:ring-aw-bluedark"
        } bg-white text-black`}
      />
      {field.maxLength && (
        <div className="flex justify-end mt-1">
          <span className="text-xs text-gray-500">
            {(value || "").length}/{field.maxLength}
          </span>
        </div>
      )}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
      {field.helpText && !error && (
        <p className="text-xs text-gray-500 mt-1">{field.helpText}</p>
      )}
    </div>
  );
}
